import styled from 'styled-components';
import MuiButton from '@mui/material/Button';

export const Wrapper = styled.div`
  position: relative;
  display: block;
  width: 100%;

  &.small {
    width: 115px;
  }

  &.white {
    .react-datepicker__input-container {
      input {
        background: ${(props) => props.theme.card.background};
      }
    }
  }

  &.date-range-picker {
    width: 638px;

    .react-datepicker .react-datepicker__month-container {
      .react-datepicker__current-month {
        display: block;
        font-size: 14px;
        font-weight: 400;
      }
    }

    .footer {
      padding: 12px;
    }
  }

  .MuiButtonBase-root {
    line-height: 1.4;
  }

  .react-datepicker-popper {
    display: inline-block;
    max-width: 250px;
    background: ${(props) => props.theme.datepicker.background};
    border-radius: 8px;
    box-shadow: 1px 5px 6px rgba(16, 16, 16, 0.66);
    z-index: 5000;
  }

  .react-datepicker__triangle {
    display: none;
  }

  .footer {
    display: flex;
    justify-content: flex-end;
    padding: 12px 1px 1px;
    border-top-width: 1px;
    border-color: ${(props) => props.theme.datepicker.driver};

    .MuiButtonBase-root {
      &.MuiButton-outlined {
        display: inline-flex;
        margin-right: 14px;
        color: ${(props) => props.theme.input.color};
      }
    }
  }

  .react-datepicker__input-container {
    input {
      display: block;
      width: 100%;
      margin-top: 4px;
      padding: 7.5px 14px;
      font-size: 14px;
      color: ${(props) => props.theme.input.color};
      background: ${(props) => props.theme.input.background};
      border: 1px solid ${(props) => props.theme.input.border};
      border-radius: 6px;
      text-align: left;

      &:focus {
        outline: 2px solid transparent;
        outline-offset: 2px;
        box-shadow: 0 0 0 3px rgba(202, 191, 253, 0.45);
        border-color: ${(props) => props.theme.input.borderFocus};
      }
    }
  }

  .react-datepicker {
    padding: 5px 0 0;
    border: 0;
    background: transparent;

    .react-datepicker__day,
    .react-datepicker__day-name,
    .react-datepicker__current-mont {
      color: ${(props) => props.theme.input.color};
    }

    .react-datepicker__year-read-view--down-arrow {
      top: 3px;
    }

    .react-datepicker__month-read-view,
    .react-datepicker__year-read-view {
      visibility: visible !important;
      color: ${(props) => props.theme.input.color};
      font-weight: bold;
      font-size: 14px;
    }

    .react-datepicker__current-month,
    .react-datepicker__year-option .react-datepicker__navigation {
      display: none;
    }

    .react-datepicker__day--disabled {
      color: ${(props) => props.theme.datepicker.disabled};
      text-decoration: line-through;
    }

    .react-datepicker__day--selected,
    .react-datepicker__day:hover,
    .react-datepicker__day--in-range,
    .react-datepicker__day--keyboard-selected {
      background: ${(props) => props.theme.datepicker.selected.background};
      color: ${(props) => props.theme.datepicker.selected.color};
      transition: background 0.3s ease;
    }

    .react-datepicker__header {
      background: transparent;
      border: 0;
    }

    .react-datepicker__navigation {
      top: 12px;
    }

    .react-datepicker__navigation-icon {
      &::before {
        border-width: 2px 2px 0 0;
      }
    }

    .react-datepicker__year-dropdown,
    .react-datepicker__month-dropdown {
      background: ${(props) => props.theme.datepicker.background};
      border-radius: 8px;
      box-shadow: 1px 5px 6px rgba(16, 16, 16, 0.66);
    }
  }

  .react-datepicker__input-time-container {
    display: block;
    margin-left: 0;
    margin-bottom: 14px;

    .react-datepicker-time__input-container {
      width: 100%;

      .react-datepicker-time__input {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        margin-left: 0;

        input[type='time'] {
          max-width: 130px;
          margin: auto;
          font-size: 0.875rem;
          line-height: 1.25rem;
          padding: 0.5rem 0.75rem;
          border-width: 1px;
          border-radius: 0.375rem;
          outline: none;
        }
      }
    }
  }
`;

export const DateRangePickerWrapper = styled.div`
  .MuiPopper-root {
    z-index: 1000;
  }

  .MuiMenuItem-root {
    &:hover,
    &.active {
      background: ${(props) => props.theme.datepicker.selected.background};
      color: ${(props) => props.theme.datepicker.selected.color};
    }
  }
`;

export const Button = styled(MuiButton)`
  &.MuiButton-root {
    background: transparent;
    border: 0;
    box-shadow: none;

    &:hover {
      background: transparent;
      border: 0;
      box-shadow: none;
    }

    .MuiTouchRipple-root {
      display: none;
    }
  }
`;
